import { PAYBACK_CAP_YEARS, RATE_ESCALATION } from './assumptions';

// Cumulative escalated savings vs net upfront cost, interpolated to one
// decimal. Returns null when payback never happens or exceeds the cap.
export const computePayback = (annualSavingsUsd: number, upfrontNetUsd: number): number | null => {
  if (annualSavingsUsd <= 0 || upfrontNetUsd <= 0) {
    return null;
  }

  let cumulative = 0;
  let yearSavings = annualSavingsUsd;

  const years = Array.from({ length: PAYBACK_CAP_YEARS }, (_, index) => index + 1);
  const paybackYear = years.reduce<number | null>((found, year) => {
    if (found !== null) {
      return found;
    }
    const fraction = (upfrontNetUsd - cumulative) / yearSavings;
    cumulative += yearSavings;
    yearSavings *= 1 + RATE_ESCALATION;
    return cumulative >= upfrontNetUsd ? Math.round((year - 1 + fraction) * 10) / 10 : null;
  }, null);

  return paybackYear !== null && paybackYear <= PAYBACK_CAP_YEARS ? paybackYear : null;
};
